import { ReactNode } from "react";

import { FormikProps, FormikValues } from "formik";

import { getFieldError } from "../../../formik/FormikField.utils";
import { useMissingFieldMessage } from "./useMissingFieldMessage";

export function useFieldError<T extends FormikValues>(
  formik: FormikProps<T>,
  path: string,
  label: ReactNode
): string | undefined {
  const missingMessage = useMissingFieldMessage(path, label);
  return getFieldError(formik, path) ?? missingMessage;
}
